import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
Vue.use(Vuex)
const debug = true
export default new Vuex.Store({
    state: {
        Token: '',
        userName:''
    },
//假设需要在state.userName基础上派生出一个新的状态newUserName出来，就适合使用getters
    getters:{
      token: state => state.token,
      newUserName:state => state.userName,
      },
    //同步方法
    mutations: {
        SET_TOKEN(state, params) {
            state.Token = params.Token;
            state.userName=params.userName;
      }
    },
    // 异步方法
   actions: {
           SET(context,Object) {
              //处理异步操作
             context.commit('SET_TOKEN',Object)
       }
   },
   plugins: debug ? [createLogger()] :[]
 })



// WEBPACK FOOTER //
// ./src/store/index.js